(ns dashboard.components.breadcrumbs)

(defn breadcrumbs [{:keys [items]}]
  [:nav.breadcrumb
   {:aria-label "breadcrumbs"}
   [:div.section.breadcrumbs
    [:ul.heading.is-size-7 {:style {:align-self "center"}}
    (for [{:keys [href label active?]} items]
      ^{:key (str href label)}
      [:li {:key label
            :class (when active? "is-active")}
       [:a {:href href} label]])]]])
